import React from "react";
import { handleChangeUnmask } from "../../../helpers/handleFormChanges";
import CommonModal from "../../../components/Common/CommonModal";
import CommonButton from "../../../components/buttons/CommonButton";
import CommonInputMask from "../../../components/forms/CommonInputMask";
import PropTypes from "prop-types";

function SolicitarAdmissaoModal({
  isOpen,
  setIsOpen,
  valuesHook,
  solicitarAdmissao,
}) {
  const { values, setValues } = valuesHook;

  return (
    <CommonModal
      title={"Solicitar admissão"}
      is_open_modal={isOpen}
      set_is_open_modal={setIsOpen}
      size="md"
      buttons={
        <CommonButton
          key={`solicitar-admissao`}
          onClick={solicitarAdmissao}
          color="success"
        >
          Solicitar admissão
        </CommonButton>
      }
    >
      <div className="row">
        <div className="col-md-6 mb-3">
          <CommonInputMask
            id="cpf"
            mask="999.999.999-99"
            onChange={(e) => handleChangeUnmask(e, values, setValues)}
            value={values.cpf}
            label="CPF do colaborador"
            required
          />
        </div>
      </div>
    </CommonModal>
  );
}

SolicitarAdmissaoModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired,
  valuesHook: PropTypes.shape({
    values: PropTypes.object.isRequired,
    setValues: PropTypes.func.isRequired,
  }).isRequired,
  solicitarAdmissao: PropTypes.func.isRequired,
};

export default SolicitarAdmissaoModal;
